import React, { createContext, useContext, useState } from "react";

// 1. Create context
const BlinkContext = createContext();

// 2. Provider component
export const BlinkProvider = ({ children }) => {
    // Store blinking state per text ID
    const [blinkingIds, setBlinkingIds] = useState(new Set());

    const startBlinking = (id) => {
        setBlinkingIds((prev) => new Set(prev).add(id));
    };

    const stopBlinking = (id) => {
        setBlinkingIds((prev) => {
            const newSet = new Set(prev);
            newSet.delete(id);
            return newSet;
        });
    };

    const isBlinking = (id) => blinkingIds.has(id);

    return (
        <BlinkContext.Provider value={{ startBlinking, stopBlinking, isBlinking }}>
            {children}
        </BlinkContext.Provider>
    );
};

// 3. Hook for easy usage
export const useBlink = () => useContext(BlinkContext);